import { createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4d0bcadc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "platform-layout-container",
  ref: "zoomContainer"
}
const _hoisted_2 = {
  class: "content",
  ref: "zoomContent"
}
const _hoisted_3 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["Page"], null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode($setup["NavigationBar"], { title: "승강장 배치도" }),
        _createElementVNode("section", _hoisted_2, [
          ($setup.busStopLayouts.length)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode($setup["SegmentedControl"], {
                  ref: "segmentedControl",
                  segments: $setup.campusNames,
                  initialIndex: $setup.currentSegmentIndex,
                  onOnChangedSegmentIndex: $setup.onChangedSegmentIndex
                }, null, 8 /* PROPS */, ["segments", "initialIndex"]),
                _createElementVNode("iframe", {
                  class: "layout",
                  src: $setup.busStopLayouts[$setup.currentSegmentIndex]?.url
                }, null, 8 /* PROPS */, _hoisted_3)
              ], 64 /* STABLE_FRAGMENT */))
            : (_openBlock(), _createBlock($setup["EmptyContent"], {
                key: 1,
                text: "승강장 배치도가 없습니다"
              }))
        ], 512 /* NEED_PATCH */)
      ], 512 /* NEED_PATCH */)
    ]),
    _: 1 /* STABLE */
  }))
}